import Delete from "@mui/icons-material/Delete";
import { useDeleteSerialEntityMutation } from "app/api/checklists";
import { useDeleteOrderSerialMutation } from "app/api/orders";
import SimpleDialog from "components/SimpleDialog";
import { Product } from "models/Product";
import { toast } from "react-toastify";

type DeleteProductDialogProps = {
  product: Product;
  orderId: string;
  checklistId?: string;
  onClose: () => void;
};

const DeleteProductDialog: React.FC<DeleteProductDialogProps> = (props) => {
  const { product, orderId, checklistId, onClose } = props;

  const [deleteSerialEntity, { isLoading: isDeletingSerialEntity }] =
    useDeleteSerialEntityMutation();
  const [deleteOrderSerial, { isLoading: isDeletingOrderSerial }] = useDeleteOrderSerialMutation();

  return (
    <SimpleDialog
      onClose={onClose}
      onConfirm={async () => {
        try {
          if (product.existing) {
            if (!checklistId) throw Error("checklistId is required to delete serial entity");
            await deleteSerialEntity({
              productId: product.id,
              checklistId: checklistId,
              orderId: orderId,
            });
          } else {
            await deleteOrderSerial({
              productId: product.id,
              checklistId: checklistId,
              orderId: product.orderNo!,
            });
          }
        } catch (error) {
          toast.error("Kunde inte radera produkten");
          console.error("Error deleting product:", error);
        }
        onClose();
      }}
      title="Radera produkten?"
      confirmProps={{
        children: "Radera",
        color: "error",
        startIcon: <Delete />,
      }}
      message="Produkten raderas helt från ordern och checklistan. Detta kan inte ångras."
      loading={isDeletingSerialEntity || isDeletingOrderSerial}
    />
  );
};

export default DeleteProductDialog;
